// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2jtUG","detailsBorder":"styles_detailsBorder__2BR8b"};